import { render, staticRenderFns } from "./tennis-icon.vue?vue&type=template&id=1270b4ac"
import script from "./tennis-icon.vue?vue&type=script&lang=js"
export * from "./tennis-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports